import { CustomerRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";

class GeographicInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      customer: {}
    };
  }

  async onZipcodeChange(value) {
    this.props.customer.address.zipcode = value.replace(/\D/g, "");
    const zipcode = value.replace(/\D/g, "");

    if (zipcode.length !== 8) {
      return;
    }

    this.enqueue({ loading: true });

    const response = await CustomerRepository.getZipcodeInfo(zipcode);

    if (response.success) {
      const { address } = this.props.customer;
      address.neighborhood = response.neighborhood;
      address.street = response.address;
      address.city = response.city;
      address.state = response.state;
      address.complement = response.addressAdditional;
    }

    this.enqueue({ loading: false });
  }
}

export default GeographicInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/form/geographic-info/presenter.js